import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * Fetches the shared buyer↔seller thread (emails + meeting recaps), oldest
 * first. Response is `{ entries, nextLastSeen }` — a real cursor: pass
 * `nextLastSeen` back as `lastSeen`; it is `null` at the end of the thread.
 */
const getSimulationConversation = (
  simulationId,
  limit,
  lastSeen,
  callback,
  errorCallback,
) => {
  return async (dispatch) => {
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.get(
            `/ads/admin/simulations/${simulationId}/conversation`,
            {
              params: {
                'request-id': reqId,
                limit: limit || 20,
                ...(lastSeen ? { lastSeen } : {}),
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            if (typeof callback === 'function')
              callback({
                entries: response?.data?.entries || [],
                nextLastSeen: response?.data?.nextLastSeen || null,
              });
          } else {
            if (typeof errorCallback === 'function')
              errorCallback('Failed to fetch conversation');
          }
        } catch (e) {
          if (typeof errorCallback === 'function')
            errorCallback(
              e?.response?.data?.message || 'Failed to fetch conversation',
            );
        }
        unsubscribe();
      });
    } catch (e) {
      if (typeof errorCallback === 'function')
        errorCallback('Failed to fetch conversation');
    }
  };
};

export default getSimulationConversation;
